import { SET_HAS_ATTACHMENT } from '../actions/hasAttachmentDataActions';

let initialState = false;

const hasAttachmentDataReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_HAS_ATTACHMENT:
            return action.payload.value
        default:
            return state;
    }
}

export default hasAttachmentDataReducer;